// Translations for Mosquée Ar-Rahman
const translations = {
  ro: {
    // Navigation
    nav: {
      home: "Acasă",
      announcements: "Anunțuri",
      certificate: "Adeverință",
      donations: "Donații",
      contact: "Contact",
      about: "Despre",
      admin: "Admin",
      login: "Autentificare",
      logout: "Deconectare",
    },
    // Home page
    home: {
      welcome: "Bine ați venit la",
      mosqueName: "Moscheea Ar-Rahman",
      subtitle: "București, România",
      description: "Un loc de rugăciune, învățare și comunitate pentru toți musulmanii din România",
      prayerTimes: "Orele de rugăciune",
      nextPrayer: "Următoarea rugăciune",
      latestNews: "Ultimele anunțuri",
      viewAll: "Vezi toate",
      quickLinks: "Acces rapid",
      getCertificate: "Adeverință sărbători islamice",
      makeDonation: "Fă o donație",
      contactUs: "Contactează-ne",
    },
    // Prayer times
    prayers: {
      fajr: "Fajr",
      sunrise: "Răsărit",
      dhuhr: "Dhuhr",
      asr: "Asr",
      maghrib: "Maghrib",
      isha: "Isha",
      countdown: "Începe în",
      hours: "ore",
      minutes: "min",
      seconds: "sec",
    },
    // Certificate form
    certificate: {
      title: "Cerere adeverință scutire pentru zile libere - sărbători islamice",
      subtitle: "Completați formularul pentru a solicita o adeverință de la moschee",
      step1: "Informații personale",
      step2: "Informații angajator",
      step3: "Contact",
      step4: "Documente",
      lastName: "Nume",
      firstName: "Prenume",
      cnp: "CNP",
      nationality: "Cetățenie",
      employerName: "Numele angajatorului",
      employerAddress: "Adresa angajatorului",
      email: "Email",
      phone: "Telefon",
      uploadId: "Încarcă carte de identitate / pașaport",
      uploadCert: "Încarcă certificat islamic (opțional)",
      next: "Următorul",
      prev: "Înapoi",
      submit: "Trimite cererea",
      success: "Cererea a fost trimisă cu succes!",
      successMsg: "Veți primi un email cu adeverința completată.",
      applyForm: "Accesați formularul",
      errors: {
        required: "Acest câmp este obligatoriu",
        cnpInvalid: "CNP-ul trebuie să aibă exact 13 cifre",
        emailInvalid: "Adresa de email nu este validă",
        fileTooBig: "Fișierul este prea mare (max 5MB)",
      },
    },
    // Donations
    donations: {
      title: "Donații",
      subtitle: "Contribuiți la dezvoltarea comunității noastre",
      bankDetails: "Date bancare",
      ronAccount: "Cont RON",
      eurAccount: "Cont EUR",
      iban: "IBAN",
      bank: "Bancă",
      beneficiary: "Beneficiar",
      taxRedirect: "Redirecționare 2%",
      taxDescription: "Puteți redirecționa 2% din impozitul pe venit către moschee",
      downloadForm: "Descarcă formularul",
      activeCampaigns: "Campanii active",
    },
    // Contact
    contact: {
      title: "Contact",
      address: "Adresă",
      phone: "Telefon",
      email: "Email",
      hours: "Program",
      openDaily: "Deschis zilnic",
      fridayPrayer: "Rugăciunea de vineri",
    },
    // About
    about: {
      title: "Despre noi",
      history: "Istoria noastră",
      mission: "Misiunea noastră",
      imam: "Imamul nostru",
    },
    // Admin
    admin: {
      dashboard: "Panou de control",
      posts: "Anunțuri",
      certificates: "Adeverințe",
      users: "Utilizatori",
      settings: "Setări",
      stats: {
        totalPosts: "Total anunțuri",
        publishedPosts: "Publicate",
        totalCertificates: "Total adeverințe",
        pendingCertificates: "În așteptare",
        signedCertificates: "Semnate",
        totalUsers: "Utilizatori",
      },
      createPost: "Creează anunț",
      editPost: "Editează anunț",
      status: {
        draft: "Ciornă",
        published: "Publicat",
        pending: "În așteptare",
        signed: "Semnat",
        sent: "Trimis",
      },
      uploadSignedPdf: "Încarcă PDF semnat",
      islamicDates: "Date islamice",
    },
    // Common
    common: {
      loading: "Se încarcă...",
      error: "Eroare",
      save: "Salvează",
      cancel: "Anulează",
      delete: "Șterge",
      edit: "Editează",
      view: "Vezi",
      search: "Caută",
      filter: "Filtrează",
      noResults: "Nu s-au găsit rezultate",
      confirm: "Confirmă",
      back: "Înapoi",
    },
    // Footer
    footer: {
      copyright: "Moscheea Ar-Rahman București. Toate drepturile rezervate.",
      followUs: "Urmărește-ne",
    },
  },
  en: {
    nav: {
      home: "Home",
      announcements: "Announcements",
      certificate: "Certificate",
      donations: "Donations",
      contact: "Contact",
      about: "About",
      admin: "Admin",
      login: "Login",
      logout: "Logout",
    },
    home: {
      welcome: "Welcome to",
      mosqueName: "Ar-Rahman Mosque",
      subtitle: "Bucharest, Romania",
      description: "A place of prayer, learning, and community for all Muslims in Romania",
      prayerTimes: "Prayer Times",
      nextPrayer: "Next Prayer",
      latestNews: "Latest Announcements",
      viewAll: "View all",
      quickLinks: "Quick Links",
      getCertificate: "Islamic Holidays Certificate",
      makeDonation: "Make a Donation",
      contactUs: "Contact Us",
    },
    prayers: {
      fajr: "Fajr",
      sunrise: "Sunrise",
      dhuhr: "Dhuhr",
      asr: "Asr",
      maghrib: "Maghrib",
      isha: "Isha",
      countdown: "Starts in",
      hours: "hrs",
      minutes: "min",
      seconds: "sec",
    },
    certificate: {
      title: "Certificate Request for Days Off - Islamic Holidays",
      subtitle: "Fill out the form to request a certificate from the mosque",
      step1: "Personal Information",
      step2: "Employer Information",
      step3: "Contact",
      step4: "Documents",
      lastName: "Last Name",
      firstName: "First Name",
      cnp: "Personal ID Number",
      nationality: "Nationality",
      employerName: "Employer Name",
      employerAddress: "Employer Address",
      email: "Email",
      phone: "Phone",
      uploadId: "Upload ID card / passport",
      uploadCert: "Upload Islamic certificate (optional)",
      next: "Next",
      prev: "Back",
      submit: "Submit Request",
      success: "Request submitted successfully!",
      successMsg: "You will receive an email with the completed certificate.",
      applyForm: "Go to the form",
      errors: {
        required: "This field is required",
        cnpInvalid: "ID number must be exactly 13 digits",
        emailInvalid: "Invalid email address",
        fileTooBig: "File is too large (max 5MB)",
      },
    },
    donations: {
      title: "Donations",
      subtitle: "Contribute to the development of our community",
      bankDetails: "Bank Details",
      ronAccount: "RON Account",
      eurAccount: "EUR Account",
      iban: "IBAN",
      bank: "Bank",
      beneficiary: "Beneficiary",
      taxRedirect: "2% Tax Redirect",
      taxDescription: "You can redirect 2% of your income tax to the mosque",
      downloadForm: "Download Form",
      activeCampaigns: "Active Campaigns",
    },
    contact: {
      title: "Contact",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Hours",
      openDaily: "Open daily",
      fridayPrayer: "Friday Prayer",
    },
    about: {
      title: "About Us",
      history: "Our History",
      mission: "Our Mission",
      imam: "Our Imam",
    },
    admin: {
      dashboard: "Dashboard",
      posts: "Posts",
      certificates: "Certificates",
      users: "Users",
      settings: "Settings",
      stats: {
        totalPosts: "Total Posts",
        publishedPosts: "Published",
        totalCertificates: "Total Certificates",
        pendingCertificates: "Pending",
        signedCertificates: "Signed",
        totalUsers: "Users",
      },
      createPost: "Create Post",
      editPost: "Edit Post",
      status: {
        draft: "Draft",
        published: "Published",
        pending: "Pending",
        signed: "Signed",
        sent: "Sent",
      },
      uploadSignedPdf: "Upload Signed PDF",
      islamicDates: "Islamic Dates",
    },
    common: {
      loading: "Loading...",
      error: "Error",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      search: "Search",
      filter: "Filter",
      noResults: "No results found",
      confirm: "Confirm",
      back: "Back",
    },
    footer: {
      copyright: "Ar-Rahman Mosque Bucharest. All rights reserved.",
      followUs: "Follow Us",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      announcements: "الإعلانات",
      certificate: "الشهادة",
      donations: "التبرعات",
      contact: "اتصل بنا",
      about: "من نحن",
      admin: "الإدارة",
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
    },
    home: {
      welcome: "مرحباً بكم في",
      mosqueName: "مسجد الرحمن",
      subtitle: "بوخارست، رومانيا",
      description: "مكان للصلاة والتعلم والمجتمع لجميع المسلمين في رومانيا",
      prayerTimes: "مواقيت الصلاة",
      nextPrayer: "الصلاة القادمة",
      latestNews: "آخر الأخبار",
      viewAll: "عرض الكل",
      quickLinks: "روابط سريعة",
      getCertificate: "شهادة الأعياد الإسلامية",
      makeDonation: "التبرع",
      contactUs: "اتصل بنا",
    },
    prayers: {
      fajr: "الفجر",
      sunrise: "الشروق",
      dhuhr: "الظهر",
      asr: "العصر",
      maghrib: "المغرب",
      isha: "العشاء",
      countdown: "تبدأ في",
      hours: "ساعات",
      minutes: "دقيقة",
      seconds: "ثانية",
    },
    certificate: {
      title: "طلب شهادة إعفاء لأيام الإجازة - الأعياد الإسلامية",
      subtitle: "املأ النموذج لطلب شهادة من المسجد",
      step1: "المعلومات الشخصية",
      step2: "معلومات صاحب العمل",
      step3: "الاتصال",
      step4: "المستندات",
      lastName: "اسم العائلة",
      firstName: "الاسم الأول",
      cnp: "رقم الهوية الشخصية",
      nationality: "الجنسية",
      employerName: "اسم صاحب العمل",
      employerAddress: "عنوان صاحب العمل",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      uploadId: "رفع بطاقة الهوية / جواز السفر",
      uploadCert: "رفع الشهادة الإسلامية (اختياري)",
      next: "التالي",
      prev: "السابق",
      submit: "إرسال الطلب",
      success: "تم إرسال الطلب بنجاح!",
      successMsg: "ستتلقى بريداً إلكترونياً مع الشهادة المكتملة.",
      applyForm: "انتقل إلى النموذج",
      errors: {
        required: "هذا الحقل مطلوب",
        cnpInvalid: "يجب أن يكون رقم الهوية 13 رقماً بالضبط",
        emailInvalid: "عنوان البريد الإلكتروني غير صالح",
        fileTooBig: "الملف كبير جداً (الحد الأقصى 5 ميجابايت)",
      },
    },
    donations: {
      title: "التبرعات",
      subtitle: "ساهم في تطوير مجتمعنا",
      bankDetails: "تفاصيل البنك",
      ronAccount: "حساب RON",
      eurAccount: "حساب EUR",
      iban: "رقم الحساب الدولي",
      bank: "البنك",
      beneficiary: "المستفيد",
      taxRedirect: "إعادة توجيه 2% من الضريبة",
      taxDescription: "يمكنك إعادة توجيه 2% من ضريبة الدخل إلى المسجد",
      downloadForm: "تحميل النموذج",
      activeCampaigns: "الحملات النشطة",
    },
    contact: {
      title: "اتصل بنا",
      address: "العنوان",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      hours: "ساعات العمل",
      openDaily: "مفتوح يومياً",
      fridayPrayer: "صلاة الجمعة",
    },
    about: {
      title: "من نحن",
      history: "تاريخنا",
      mission: "مهمتنا",
      imam: "إمامنا",
    },
    admin: {
      dashboard: "لوحة التحكم",
      posts: "المنشورات",
      certificates: "الشهادات",
      users: "المستخدمون",
      settings: "الإعدادات",
      stats: {
        totalPosts: "إجمالي المنشورات",
        publishedPosts: "المنشورة",
        totalCertificates: "إجمالي الشهادات",
        pendingCertificates: "قيد الانتظار",
        signedCertificates: "الموقعة",
        totalUsers: "المستخدمون",
      },
      createPost: "إنشاء منشور",
      editPost: "تعديل المنشور",
      status: {
        draft: "مسودة",
        published: "منشور",
        pending: "قيد الانتظار",
        signed: "موقع",
        sent: "مرسل",
      },
      uploadSignedPdf: "رفع PDF الموقع",
      islamicDates: "التواريخ الإسلامية",
    },
    common: {
      loading: "جاري التحميل...",
      error: "خطأ",
      save: "حفظ",
      cancel: "إلغاء",
      delete: "حذف",
      edit: "تعديل",
      view: "عرض",
      search: "بحث",
      filter: "تصفية",
      noResults: "لم يتم العثور على نتائج",
      confirm: "تأكيد",
      back: "رجوع",
    },
    footer: {
      copyright: "مسجد الرحمن بوخارست. جميع الحقوق محفوظة.",
      followUs: "تابعنا",
    },
  },
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang] || translations.ro;
  
  for (const k of keys) {
    result = result?.[k];
    if (!result) break;
  }
  
  return result || key;
};

export const t = getTranslation;

export const languages = [
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', rtl: true },
];

export default translations;
